
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "column": "column-7d14f675",
    "fit-height": "fit-height-7d14f675",
    "fit-width": "fit-width-7d14f675",
    "fit-both": "fit-both-7d14f675",
    "center": "center-7d14f675",
    "middle": "middle-7d14f675",
    "spacing-none": "spacing-none-7d14f675",
    "spacing-normal": "spacing-normal-7d14f675",
    "spacing-narrow": "spacing-narrow-7d14f675",
    "spacing-wide": "spacing-wide-7d14f675",
    "fitHeight": "fit-height-7d14f675",
    "fitWidth": "fit-width-7d14f675",
    "fitBoth": "fit-both-7d14f675",
    "spacingNone": "spacing-none-7d14f675",
    "spacingNormal": "spacing-normal-7d14f675",
    "spacingNarrow": "spacing-narrow-7d14f675",
    "spacingWide": "spacing-wide-7d14f675"
};
exports.styleSource = ".column-7d14f675{display:flex;flex-direction:column;align-items:flex-start;width:fit-content}.fit-height-7d14f675{height:100%}.fit-width-7d14f675{width:100%;align-items:stretch}.fit-both-7d14f675{width:100%;height:100%;align-items:stretch}.center-7d14f675{width:100%;align-items:center}.middle-7d14f675{justify-content:center;height:100%}.spacing-none-7d14f675>*{margin:0}.spacing-normal-7d14f675>*{margin-bottom:1em}.spacing-normal-7d14f675>*:last-child{margin-bottom:0}.spacing-narrow-7d14f675>*{margin-bottom:.5em}.spacing-narrow-7d14f675>*:last-child{margin-bottom:0}.spacing-wide-7d14f675>*{margin-bottom:2em}.spacing-wide-7d14f675>*:last-child{margin-bottom:0}";
exports.default = exports.styles;
            
module.moduleType = "style";
